import React, { useState, useEffect, useRef, useContext } from "react";
import Slider from "react-slick";
import Marquee from "react-fast-marquee";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";

interface AutoMarqueeProps {
  children: React.ReactNode;
  speed?: number;        
  pauseOnHover?: boolean;
  gradient?: boolean;
  onSpeedChange?: (speed: number) => void; 
  resetTrigger?: number;
  index: number;
}

const AutoMarquee: React.FC<AutoMarqueeProps> = ({
  children,
  speed = 50,
  pauseOnHover = true,
  gradient = false,
  onSpeedChange,
  resetTrigger,
  index,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLSpanElement>(null);
  const [shouldMarquee, setShouldMarquee] = useState(false);
  const onSpeedChangeRef = useRef(onSpeedChange);
  useEffect(() => {
    onSpeedChangeRef.current = onSpeedChange;
  }, [onSpeedChange]);
  const lastReportedRef = useRef<number | null>(null);
  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && contentRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const contentWidth = contentRef.current.scrollWidth;
        const overflow = contentWidth > containerWidth;
        setShouldMarquee(overflow);

        // Eğer metin taşarsa dinamik süre hesapla,
        // aksi halde marquee ihtiyacı yoksa belirli süre beklet.
        const baseSpeed = 3000; // Temel bekleme süresi (ms)
        let dynamicAutoplaySpeed = baseSpeed; 
        if (overflow) {
          const adjustmentFactor = (contentWidth - containerWidth) / speed;
          dynamicAutoplaySpeed = adjustmentFactor * 1000;
        }
       // console.log(`index ${index} - text width: ${contentWidth}, container: ${containerWidth}, autoplay: ${dynamicAutoplaySpeed} ms`);

        if (lastReportedRef.current !== dynamicAutoplaySpeed) {
          lastReportedRef.current = dynamicAutoplaySpeed;
          onSpeedChangeRef.current?.(dynamicAutoplaySpeed);
        }
      }
    };

    checkOverflow();

    window.addEventListener("resize", checkOverflow);
    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [children, resetTrigger, speed]);

  return (
    <div ref={containerRef} style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
      {shouldMarquee ? (
        <Marquee
          key={resetTrigger}
          gradient={gradient}
          speed={speed}
          pauseOnHover={pauseOnHover}
        >
          <span ref={contentRef}>{children}</span>
        </Marquee>
      ) : (
        <span ref={contentRef}>{children}</span>
      )}
    </div>
  );
};

function NotificationSlider() {
  // onSpeedChange prop'u ile hızlar dinamik olarak güncellenecek.
  const [marqueeSpeeds, setMarqueeSpeeds] = useState<number[]>([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const {duyurularListe}=useContext(ConstantAPISContext)

  const settings = {
    dots: false,
    infinite: true,
    speed: 500, // Slider geçiş animasyon süresi
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    autoplay: true, // Dinamik hesaplanan süre kullanılarak slide'lar arası geçiş yapılır.
    autoplaySpeed: marqueeSpeeds[currentSlide] || 3000,
    arrows: false,
    beforeChange: (_: number, next: number) => setCurrentSlide(next),
  };

  const handleSpeedChange = React.useCallback((newSpeed: number, index: number) => {
    setMarqueeSpeeds((prev) => {
      if (prev[index] === newSpeed) return prev;
      const updated = [...prev];
      updated[index] = newSpeed;
      return updated;
    });
  }, []);

  

  const [resetKeys, setResetKeys] = useState<number[]>(Array(duyurularListe.length).fill(0));

  useEffect(() => {
    const handleResize = () => {
      setResetKeys((prev) => {
        const updated = [...prev];
        updated[currentSlide] = prev[currentSlide] + 1;
        return updated;
      });
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [currentSlide]);


  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Slider {...settings}>
        {duyurularListe.map((msg, idx) => (
          <div key={idx} className="d-flex flex-row gap-1 align-items-center w-100">
            <img className="d-flex" src="fire.gif" alt="" />
            <div className="notification-light-text w-100">
              <AutoMarquee
                gradient={false}
                speed={50}
                pauseOnHover={true}
                onSpeedChange={(s) => handleSpeedChange(s, idx)}
                resetTrigger={currentSlide}
                index={idx}
                key={resetKeys[idx]} 
              >
                {msg.icerik}
              </AutoMarquee>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default NotificationSlider;